import { CommonMessage } from '@frontend/lang';
import { Package } from '@frontend/package/types';
import { SlotBadge } from '@frontend/slot/badge';
import { UserBadge } from '@frontend/user/badge';
import React from 'react';

import { PackageInfo } from '../drop-off/pudo-drop-list.controller';
import usePackageCard from './package-card.controller';

export interface PackageCardProps {
    packageInfo: PackageInfo;
    isSelected?: boolean;
    onDropOff?: (_package: Package) => void;
    onPickUp?: (_package: Package) => void;
}

const PackageCard = (props: PackageCardProps) => {
    const viewProps = usePackageCard(props);
    return (
        <div
            className={`card ms-3 mt-3 ${props.isSelected ? 'w-100' : 'w-48'}`}
            key={props.packageInfo.package.id}>
            <div className='card-body'>
                <h5 className='card-title mb-3'>{props.packageInfo.transaction.tracking_number}</h5>
                <div className='d-flex flex-column'>
                    <div className='d-flex justify-content-between mb-3 flex-row'>
                        <p className='font-weight-bolder text-lg'>{CommonMessage.OBJECTS.SLOT.DEFAULT}</p>
                        <SlotBadge
                            className='badge badge-secondary text-lg'
                            id={props.packageInfo.package.slot_id}
                        />
                    </div>
                    {props.packageInfo.transaction.senders && props.packageInfo.transaction.senders.length > 0 && (
                        <div className='d-flex justify-content-between mb-3 flex-row'>
                            <p className='font-weight-bolder text-lg'>{CommonMessage.OBJECTS.TRANSACTION.SENDER}</p>
                            <UserBadge
                                id={props.packageInfo.transaction.senders[0].entity_id}
                                className='badge badge-secondary text-lg'
                            />
                        </div>
                    )}
                    {props.packageInfo.transaction.receivers && props.packageInfo.transaction.receivers.length > 0 && (
                        <div className='d-flex justify-content-between mb-3 flex-row'>
                            <p className='font-weight-bolder text-lg'>{CommonMessage.OBJECTS.TRANSACTION.RECEIVER}</p>
                            <UserBadge
                                id={props.packageInfo.transaction.receivers[0].entity_id}
                                className='badge badge-secondary text-lg'
                            />
                        </div>
                    )}
                </div>
            </div>
            <div className='card-footer'>
                <button
                    id={`${props.onDropOff ? 'dropoff' : 'pickup'}-button`}
                    className='btn btn-success w-100'
                    onClick={() => {
                        props.onDropOff && props.onDropOff(props.packageInfo.package);
                        props.onPickUp && props.onPickUp(props.packageInfo.package);
                    }}>
                    {props.onDropOff ? CommonMessage.BUTTONS.DROP_OFF : CommonMessage.BUTTONS.PICK_UP}
                </button>
            </div>
        </div>
    );
};

export default PackageCard;
